// extracted by mini-css-extract-plugin
export default {"modal":"ModalImage_modal__Ls10z","modal-img":"ModalImage_modal-img__l2XGS"};